import { CheckIcon, XIcon } from "lucide-react";
import type { FC } from "react";
import { cn } from "@/lib/cn";

export const ResultBadge: FC<{
  result: "correct" | "wrong" | "hidden";
  className?: string;
}> = ({ result, className }) => (
  <div
    className={cn(
      "flex h-6 w-6 items-center justify-center rounded-full",
      result === "correct" && "bg-success text-primary-foreground",
      result === "wrong" && "bg-destructive text-primary-foreground",
      result === "hidden" && "invisible",
      className,
    )}
  >
    {result === "correct" && <CheckIcon className="h-4 w-4" />}
    {result === "wrong" && <XIcon className="h-4 w-4" />}
  </div>
);
